<template>
  <div class="item"
    :class="{library: library, open: isFold}">
    <div class="openLibrary">
      <button type="button" class="addChannel toCapitalize"
        @click="setLibrary()">
        {{locale.tv_select_channel}}
      </button>
      <button type="button" class="newChannel toCapitalize"
        @click="isFold = !isFold">
        {{locale.tv_add_channel}}
        <span class="btnFold"></span>
      </button>
    </div>
    <div class="box">
      <ChanneLibrary v-if="library"
        :locale="locale"
        :type="libType"
        @close="onCloseLibrary" />
      <div class="option">
        <div class="loadLibrary">
          <button type="button" class="btn btnFull loadChannel toCapitalize"
            @click="setLibrary('radio')">
            {{locale.tv_load_channel}}
          </button>
        </div>
        <div class="optionItem">
          <div class="uploadChLogo" :class="{hasLogo: item.logo !== ''}">
            <img v-if="item.logo !== ''" :src="item.logo" class="channelLogo" alt="">
            <label for="uploadChLogo_new">
              <input type="file" id="uploadChLogo_new" @change="uploadLogo($event)">
              <img src="@/assets/img/ico_upload_image.svg" alt="" />
            </label>
          </div>
        </div>
        <div class="optionItem">
          <label class="optionLabel toCapitalize">{{locale.name}}</label>
          <input type="text" class="optionValue input" v-model="item.name">
        </div>
        <div class="optionItem">
          <label class="optionLabel toCapitalize">{{locale.no}}</label>
          <input type="text" class="optionValue input" v-model="item.no">
        </div>
        <div class="optionItem">
          <label class="optionLabel toCapitalize">{{locale.genre}}</label>
          <select class="optionValue input toCapitalize" v-model="item.genre">
            <option v-for="g in genre" :key="g" :value="g">{{getGenreName(g)}}</option>
          </select>
        </div>
        <div class="optionItem">
          <label class="optionLabel toCapitalize">{{locale.language}}</label>
          <select class="optionValue input" v-model="item.lang">
            <option v-for="l in lang" :key="l" :value="l">{{langName(l)}}</option>
          </select>
        </div>
        <div class="optionBtns">
          <button type="button" class="btn btnWhite toCapitalize" @click="clearCh">{{locale.cancel}}</button>
          <button type="button" class="btn btnPrimary toCapitalize" @click="addCh">{{locale.add}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ChanneLibrary from '@/components/Tv/Library.vue'

export default {
  props: [
    'locale',
    'genre',
    'lang'
  ],
  components: {
    ChanneLibrary
  },
  computed: {
    item () {
      return this.$store.getters['tv/loadChannel']
    }
  },
  data () {
    return {
      library: false,
      libType: 'checkbox',
      isFold: false
    }
  },
  methods: {
    langName (c) {
      const code = `lang_${c}`
      return this.locale[code]
    },
    getGenreName (id) {
      const genre = `genre_${id}`
      return this.locale[genre]
    },
    setLibrary (type) {
      this.library = true
      this.libType = type || 'checkbox'
    },
    onCloseLibrary () {
      this.library = false
    },
    uploadLogo (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.$store.commit('tv/updateChLogo', { logo: res.source })
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    validateOnAdd () {
      const data = this.item
      if (data.logo === '') {
        alert(this.locale.validate_channel_logo)
      } else if (data.name.trim() === '') {
        alert(this.locale.validate_channel_name)
      } else if (data.no.trim() === '') {
        alert(this.locale.validate_channel_no)
      } else if (data.genre.trim() === '') {
        alert(this.locale.validate_channel_genre)
      } else if (data.lang.trim() === '') {
        alert(this.locale.validate_channel_lang)
      } else {
        return true
      }
    },
    addCh () {
      if (this.validateOnAdd()) {
        if (window.confirm(this.locale.confirm_channel_add)) {
          const data = {
            ...this.item,
            id: UNIQUE.mid(),
            visible: true
          }
          this.$store.commit('onLoading', true)
          this.$store.dispatch('tv/addCh', data).then(() => {
            this.$store.dispatch('tv/setChannel').then(() => {
              this.$store.dispatch('tv/getChData')
              this.$store.commit('tv/initCh')
              alert(this.locale.complete_channel_add)
              this.$store.commit('onLoading', false)
            })
          })
        }
      }
    },
    clearCh () {
      if (window.confirm(this.locale.confirm_channel_reset)) {
        this.$store.commit('tv/initCh')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  position: relative;
}
.chList .open {
  border-color: $color-lgrey2;
  .newChannel {
    color: $color-primary;
    border-color: $color-primary;
    border-radius: 0 4px 0 0;
    background-color: $color-white;
    .btnFold {
      background-color: $bg-default;
    }
  }
}
.uploadChLogo {
  display: block;
  position: relative;
  text-align: center;
  border-radius: 8px;
  border: 1px solid $color-lgrey2;
  background-color: $color-white;
  label {
    display: block;
    padding: 10px;
    cursor: pointer;
    img {
      opacity: 0.5;
    }
  }
  &.hasLogo {
    padding: 10px;
    label {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 40px;
      height: 40px;
      padding: 5px;
      border: 1px solid $color-lgrey2;
      border-radius: 100%;
      background-color: $bg-default;
      transform: translate(-50%, -50%);
      opacity: 0.5;
      img {
        opacity: 1;
      }
    }
    &:hover label {
      display: block;
    }
  }
}
.openLibrary {
  display: flex;
  position: relative;
  font-size: 0.85em;
  border-radius: 4px;
  background-color: $bg-default;
  button {
    flex: 1;
    height: 124px;
    padding-bottom: 10px;
    &:before {
      content: "";
      display: block;
      width: 40px;
      height: 40px;
      margin: -10px auto 3px;
      border-radius: 100%;
      border: 1px solid $color-lgrey;
      background-position: 50% 50%;
      background-size: 24px;
      background-repeat: no-repeat;
      background-color: $color-white;
      opacity: 0.5;
    }
  }
}
.newChannel {
  position: relative;
  border: 1px solid transparent;
  border-bottom: none;
  border-left-color: $color-white;
  &:before {
    background-image: url('~@/assets/img/ico_add.png');
  }
  .btnFold {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
.addChannel {
  border: 1px solid transparent;
  border-right-color: $color-lgrey2;
  &:before {
    background-image: url('~@/assets/img/ico_import.png');
  }
}
.library .addChannel {
  color: $color-primary;
  border: 1px solid $color-primary;
  border-radius: 4px 0 0 4px;
}
.loadLibrary {
  margin: -15px -15px 15px;
  font-size: 0.9em;
  .btn {
    padding-left: 0;
    padding-right: 0;
  }
}
.optionBtns {
  display: flex;
  border-top: 1px solid $color-lgrey2;
  .btn {
    flex: 1;
  }
}
</style>
